import { APP_ENV } from "@/lib/config";

/**
 * Client-side email validation before auth API calls.
 * Plus-address blocking when NEXT_PUBLIC_APP_ENV is production (see APP_ENV in lib/config).
 */
export const PLUS_ALIAS_NOT_SUPPORTED_MESSAGE =
  "Email aliases (using ‘+’) are not supported. Please enter your primary email address.";

export function validateEmail(email: string): string | null {
  const normalized = email.trim().toLowerCase();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(normalized)) {
    return "Invalid email format";
  }

  const [local] = normalized.split("@");

  if (
    APP_ENV === "production" &&
    local.includes("+")
  ) {
    return PLUS_ALIAS_NOT_SUPPORTED_MESSAGE;
  }

  return null;
}
